export default __webpack_public_path__ + "static/media/Manisha Pathak.67fa114e.jpg";